<template>
  <div>
    <div class="bg-black">
    </div>
    <div class="section-panel">
      <div class="container-fluid text-center">
        <div class="row">
          <div class="col-md-9 col-lg-9">
            <form-wizard @on-complete="onComplete" 
            title="Bienvenido" 
            subtitle="Pasos para invertir"
            :backButtonText="$t('investment.button_prev')"
            :nextButtonText="$t('investment.button_next')"
            finishButtonText="Finalizar"
            color="#333333">
              <tab-content title="Paso 1"
                          icon="ti-user"
                          :before-change="valStep1">
                <div class="card plain">
                  <div class="card-body">
                      <h4 class="card-title">¿Cómo te gustaría invertir?</h4>
                      <span class="card-subtitle mb-2 text-muted">Dependiendo de cómo decidas invertir tendrás que presentar distintos tipos de documentos.</span>
                      
                      <el-divider></el-divider>

                      <br>
                      <div class="row p-2">
                        <div class="col-md-3">
                          
                        </div>
                        <div class="col-md-3">
                          <div class="btn btn-info" v-on:click="setMoral('P')">
                            <font-awesome-icon icon="user-alt" style="font-size: 60px !important;"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="btn btn-info" v-on:click="setMoral('E')">
                            <font-awesome-icon icon="building" style="font-size: 60px !important;"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>
                      
                      <div class="row p-2">
                        <div class="col-md-3">
                          
                        </div>
                        <div class="col-md-3">
                          <el-radio v-model="formData.user_type" label="P">Personal</el-radio>
                        </div>
                        <div class="col-md-3">
                          <el-radio v-model="formData.user_type" label="E">Empresa</el-radio>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>
                  </div>
                </div>
              </tab-content>
              <tab-content title="Paso 2"
                          icon="ti-settings"
                          :before-change="valStep2">
                <div class="card plain">
                  <div class="card-body">
                      <!-- Información personal -->

                      <h4 class="card-title">Información personal</h4>
                      <span class="card-subtitle mb-2 text-muted">Complementa tu información personal.</span>
                      
                      <el-divider></el-divider>

                      <br>
                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                :label="$t('users.name')"
                                class="has-label input-lg"
                                v-model="formData.name"
                            ></fg-input>
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                :label="$t('users.email')"
                                class="has-label input-lg"
                                v-model="formData.email"
                                disabled
                            ></fg-input>
                        </div>
                        <div class="col-md-2">
                        </div>
                      </div>

                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                :label="$t('users.phone')"
                                class="has-label input-lg"
                                v-model="formData.phone"
                            ></fg-input>
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                label="RFC"
                                class="has-label input-lg"
                                v-model="formData.rfc"
                            ></fg-input>
                        </div>
                        <div class="col-md-2">
                        </div>
                      </div>

                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-8">
                            <fg-input
                                :label="$t('users.address')"
                                class="has-label input-lg"
                                v-model="formData.address"
                            ></fg-input>
                        </div>
                        <div class="col-md-2">
                        </div>
                      </div>
                      
                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                label="Estado"
                                class="has-label input-lg"
                                v-model="formData.state"
                            ></fg-input>
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                label="Ciudad"
                                class="has-label input-lg"
                                v-model="formData.city"
                            ></fg-input>
                        </div>
                        <div class="col-md-2">
                        </div>
                      </div>

                      
                  </div>
                </div>
              </tab-content>
              <tab-content title="Paso 3"
                          icon="ti-credit-card"
                          :before-change="valStep3">
                <div class="card plain">
                  <div class="card-body">
                <!-- Información de pago -->
                      <h4 class="card-title">Información de Pago</h4>
                      <span class="card-subtitle mb-2 text-muted">Selecciona el monto de inversión y la forma de pago.</span>
                      
                      <el-divider></el-divider>
                      <br>
                      <div class="row p-2">
                        <div class="col-md-12">
                          <span class="demo-input-label">Montos</span>
                          <el-select clearable filterable placeholder="Select" v-model="formData.ammount_investment" size="large">
                            <el-option
                              v-for="a in ammounts"
                              :key="a.id"
                              :label="a.ammountF"
                              :value="a.ammount">
                              <span style="float: left">${{ a.ammountF }}</span>
                              <span v-if="a.is_minimal" style="float: right; color: #F13710; font-size: 13px; width: 150px;">&nbsp;- Monto mínimo</span>
                            </el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="row p-2">
                        <div class="col-md-3">
                          
                        </div>
                        <div class="col-md-3">
                          <el-radio v-model="formData.payment_type" label="TB">Transferencia bancaria</el-radio>
                        </div>
                        <div class="col-md-3">
                          <el-tooltip content="Los depósitos en ventanilla " placement="right" effect="light">
                            <el-radio v-model="formData.payment_type" label="DC">Depósito Ventanilla</el-radio>
                          </el-tooltip>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>

                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                label="Número de Cuenta"
                                class="has-label input-lg"
                                v-model="formData.card_number"
                            ></fg-input>
                        </div>
                        <div class="col-md-4">
                            <fg-input
                                label="Banco"
                                class="has-label input-lg"
                                v-model="formData.bank_name"
                            ></fg-input>
                        </div>
                        <div class="col-md-2">
                        </div>
                      </div>
                  </div>
                </div>
      
              </tab-content>
              <tab-content title="Paso 4"
                          icon="ti-check"
                          :before-change="valStep4">
                <div class="card plain">
                  <div class="card-body">
                <!-- Documentos legales -->
                      <h4 class="card-title">Documentos Legales</h4>
                      <el-divider></el-divider>
                      <br>
                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-6 text-left">
                          <el-checkbox v-model="formData.check1">He revisado con cuidado la información contenida en el documento</el-checkbox>
                        </div>
                        <div class="col-md-4">
                        </div>
                      </div>
                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-6 text-left">
                          <el-checkbox v-model="formData.check2">He revisado, entendido, y aceptado el documento</el-checkbox>
                        </div>
                        <div class="col-md-4">
                        </div>
                      </div>
                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-6 text-left">
                          <el-checkbox v-model="formData.check3">Confirmación 1</el-checkbox>
                        </div>
                        <div class="col-md-4">
                        </div>
                      </div>

                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-6 text-left">
                          <el-checkbox v-model="formData.check4">Confirmación 2</el-checkbox>
                        </div>
                        <div class="col-md-4">
                        </div>
                      </div>
                      <div class="row p-2">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-6 text-left">
                          <el-checkbox v-model="formData.check5">Confirmación 3</el-checkbox>
                        </div>
                        <div class="col-md-4">
                        </div>
                      </div>

                      <h4 class="card-title">Firma</h4>
                      <el-divider></el-divider>
                      <signature-form :user-id="userId" @input="(sig) => { formData.signature = sig }"></signature-form>
                  </div>
                </div>
              </tab-content>
            </form-wizard>
          </div>
          <div class="col-md-3 col-lg-3">
            <br><br><br>
            <project-view :data="formProject"> </project-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormGroupInput } from '@/components';
import { Divider, Button, Radio, Checkbox, Select, Option, Tooltip, MessageBox, Message } from 'element-ui';
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ThemifyIcon from "vue-themify-icons"
import SignatureForm from '../pages/components/SignatureForm';
import ProjectView from '../pages/components/ProjectView';
import _ from "lodash"

import Investments from '@/providers/Investments'
const provider = new Investments()

import Settings from '@/providers/Settings'
const providerSettings = new Settings()

export default {
  name: 'invest',
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    FormWizard,
    TabContent,
    SignatureForm,
    ProjectView
  },
  data() {
    return {
      projectId: this.$route.params.id,
      formData: {
        name: null,
        phone: null,
        email: null,
        address: null,
        rfc: null,
        country_id: null,
        ammount_investment: null,
        payment_type: null,
        bank_name: null,
        card_number: null,
        user_type: null,
        signature: null
      },
      formProject: {
        id: null,
        name: null,
        start_at: null,
        end_at: null,
        ammount_total: null,
        summary: null,
        stage_id: null,
        thumbnails: null
      },
      isMoral: null,
      userId: null,
      ammounts: [],
      loading: false,
      minimal: null
    }
  },
  mounted() {
    if (this.$store.state.user) {
      if (this.$route.params.id) {
        let user = this.$store.state.user
        this.userId = user.id
        this.formData.name = user.name
        this.formData.email = user.email
        this.formData.phone = user.phone
        this.formData.rfc = user.rfc
        this.formData.address = user.address

        this.getProject()
      } else {
        this.$router.push({name: 'detail'})
      }
    }else {
      this.$router.push({name: 'index'})
    }    
  },
  methods: {
    onComplete(){
      this.loading = true
      provider.createInvest(this.projectId, this.formData).then((resp)=> {
        Message({ effect: "dark",  type: 'success', message: '¡Felicidades!, tu registro se ha realizado, espera instrucciones por correo electrónico.' })
        setTimeout(() => {
          // this.$router.push({path: '/investment/registered', query: {_tk: resp.data.token} })
          this.$router.push('/panel')
        }, 3000);
      }).catch((err)=>{
        Message({ type: 'error', message: 'Datos inválidos' })
        this.loading = false
      })
    },
    valStep1() {
      return !_.isNull(this.formData.user_type)
    },
    valStep2(){
      return !_.isNull(this.formData.name) 
      && !_.isNull(this.formData.phone) 
      && !_.isNull(this.formData.email) 
      && !_.isNull(this.formData.address)
    },
    valStep3() {
      let valid = false
      if (!_.isNull(this.formData.ammount_investment)
      && !_.isNull(this.formData.payment_type)) {
        valid = true
      }
      return valid
    },
    valStep4(){
      return true
    },
    setMoral(value){
      this.formData.user_type = value.toString()
    },
    getProject() {
      if (this.$route.params && this.$route.params.id) {
        provider.getInvestmentPublic(this.$route.params.id).then((response) => {
          let data = response.data.data
          console.info('get project response', data)
          if(data && data.attributes) {
            this.formProject.id = data.id
            this.formProject.name = data.attributes.name
            this.formProject.start_at = data.attributes.start_at
            this.formProject.end_at = data.attributes.end_at
            this.formProject.ammount_total = data.attributes.ammount_total
            this.formProject.ammount_recauded_percentage = data.attributes.ammount_recauded_percentage
            this.formProject.summary = data.attributes.summary
            this.formProject.stage_id = data.attributes.stage_id
            this.formProject.thumbnails = data.attributes.thumbnails
            this.ammounts = data.attributes.ammounts_investment
            this.setMinimalAmmount(this.ammounts)
          }
        }).catch((err) => {
          console.info('error get project request')
          console.info(err)
        })
      }
    },
    setMinimalAmmount(ammounts) {
      let minimal = _.find(ammounts, (a) => { return a.is_minimal == 1  })
      this.minimal = minimal
    }
  }
};
</script>
<style>
</style>
